// @flow
import { createRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Heading,
  QuestionWrapper,
  RadioButtons,
  type RadioButtonsOptions,
} from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const validate = validatePresence("urgency", "Please select an option");

const allOptions: RadioButtonsOptions<CustomerUrgencyValue> = [
  {
    value: "LESS_THAN_THREE_MONTHS",
    label: "In the next 3 months",
  },
  {
    value: "THREE_TO_SIX_MONTHS",
    label: "In 3-6 months",
  },
  {
    value: "SIX_MONTHS_PLUS",
    label: "In 6+ months",
  },
  {
    value: "NOT_SELLING",
    label: "I'm not planning on selling",
  },
];

type Props = {
  ...QuestionProps<"urgency">,
  initialModalOpen?: boolean,
};

export const ValuationUrgency = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: Props) => {
  const [urgency, setUrgency] = useState(initialValue);
  const { customerIntent } = useSelector((state) => state.onboardingForm);

  // Exclude the NOT_SELLING option unless the customer is JUST_CURIOUS
  const options = allOptions.filter(
    (option) =>
      option.value !== "NOT_SELLING" || customerIntent === "JUST_CURIOUS",
  );

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <QuestionWrapper
      next={() => next(urgency, validate)}
      dataTest="valuation-urgency-question"
    >
      <BackButton />
      <Heading>When are you thinking of selling?</Heading>
      <RadioButtons
        data-test="valuation-urgency-radios"
        errorMessage={validationErrors.urgency}
        hasErrors={!valid}
        name="urgency"
        onChange={(value) => setUrgency(value)}
        options={options}
        ref={ref}
        value={urgency}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
